import { render, staticRenderFns } from "./CrossConnects.vue?vue&type=template&id=f936a6ac&scoped=true&"
import script from "./CrossConnects.vue?vue&type=script&lang=js&"
export * from "./CrossConnects.vue?vue&type=script&lang=js&"
import style0 from "./CrossConnects.vue?vue&type=style&index=0&id=f936a6ac&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f936a6ac",
  null
  
)

export default component.exports